module.exports = __webpack_public_path__ + "img/52d0ba6.png";